export default __webpack_public_path__ + "static/media/content-section_custom.3c559fd4.svg";